module.exports = __webpack_public_path__ + "static/img/banner2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/banner2.png
// module id = 539
// module chunks = 0